import React from 'react';

const SvgLogoVg = (props: any) => (
    <svg width={35} height={35} {...props}>
        <g fillRule="nonzero" fill="none">
            <circle fill="#CB361F" cx={17.5} cy={17.5} r={17.5} />
            <path
                d="M17.216 16.666L19 14h-4.883c-.894 1.596-1.728 3.223-2.621 4.713l-.029-.034L8.965 14H4l4.776 7h5.46l2.98-4.334M25.079 18.057c.718.005 1.423.001 2.16.001 0 .546.07 1.157-.07 1.639-.118.246-.302.454-.529.517-1.089-.011-2.126.006-3.285 0-.262-.05-.521-.403-.575-.703v-3.803l.07-.41c.097-.213.297-.397.48-.476h3.156l.254.04c.33.162.472.54.508.958h3.733c-.003-.365-.057-.75-.178-1.058-.168-.395-.562-.688-.908-.744h-8.31s-1.237-.092-1.952.137c-.357.204-.603.679-.619 1.15l-.013 3.582c.043.502-.103 1.103.178 1.478.246.467.672.576 1.086.63h9.033c.343-.004.708.052.997-.132.386-.227.635-.7.697-1.216L31 17.288h-5.924l.003.77"
                fill="#FFF"
            />
        </g>
    </svg>
);

export default SvgLogoVg;
